import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA3B9xTYsm7qjDx4niyhpJp-Ai_wnB9x7Y",
  authDomain: "coaching-inquiry-form.firebaseapp.com",
  projectId: "coaching-inquiry-form",
  storageBucket: "coaching-inquiry-form.firebasestorage.app",
  messagingSenderId: "946372794785",
  appId: "1:946372794785:web:c739b6a8b07fee4e4053e0",
  measurementId: "G-2V4L912LQQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app; 